<template>
  <div>
    <q-dialog v-model="valueLocal" persistent>
      <q-card class="card-authorization">
        <q-card-section class="header">
          <div class="text-h6" id="title-card-authorization">
            Añadir instrumento / Plan
          </div>
        </q-card-section>
        <q-card-section class="container-auth q-pt-none q-col-gutter-y-sm">
          <slot name="body">
           <HeaderPopUp/>

            <!--Nombre-->
            <div class="row">
              <q-input
                outlined
                label="Nombre"
                class="col-12 required"
                v-model.trim="$v.nombre.$model"
                :error="$v.nombre.$error"
              >
                <template v-slot:error>
                  <span>Dato obligatorio.</span>
                </template>
              </q-input>
            </div>
            <!--fase-->
            <!--periodo de vigencia-->
            <div class="row">
              <q-select
                label="Fases"
                class="input col-6 fase required"
                outlined
                :options="optionsFases ? optionsFases : 'No hay datos'"
                option-value="id"
                option-label="name"
                v-model="optionSelected"
                :error="$v.optionSelected.$error"
              >
                <template v-slot:error>
                  <span>Dato obligatorio.</span>
                </template>
              </q-select>
              <q-input
                v-model.trim="$v.periodoVigencia.$model"
                outlined
                label="Período de vigencia"
                class="col-6 periodo required"
                :error="$v.periodoVigencia.$error"
              >
                <template v-slot:error>
                  <span>Dato obligatorio.</span>
                </template>
              </q-input>
            </div>
            <div class="row">
              <q-file
              class="col-6 file"
              outlined
              v-model="file"
              label="Seleccione archivo"
              max-file-size="10485760"
              accept=".pdf"
              @rejected="onRejected">
                <template v-slot:append>
                  <q-icon name="attachment"></q-icon>
                </template>
              </q-file>
            </div>
            <!--observaciones-->
            <div class="row">
              <q-input
                v-model="observaciones"
                type="textarea"
                label="Observaciones"
                outlined
                class="col-12"
              ></q-input>
            </div>
          </slot>
        </q-card-section>

        <q-card-actions align="right" class="text-primary container-actions">
          <q-btn
            class="bSecondary"
            flat
            label="Cancelar"
            v-close-popup
            @click="cancel()"
          />
          <q-btn
            label="AÑADIR INSTRUMENTO/PLAN"
            class="bPrincipal"
            padding="xs lg"
            @click="save()"
            :disabled="!isValidFrom()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { QDialog } from 'quasar';
import * as types from '@/storeModules/NGUD/types';
import { required } from 'vuelidate/lib/validators';
import HeaderPopUp from '@/components/PlanAccion/components/HeaderPopUp.vue';
import Message from '@/components/shared/mixins/Message.js';
export default {
  components: {
    QDialog,
    HeaderPopUp
  },
  mixins: [Message],
  props: {
    value: {
      required: true
    }
  },
  validations: {
    nombre: { required },
    periodoVigencia: { required },
    optionSelected: { required }
  },
  data () {
    return {
      valueLocal: this.value,
      nombre: '',
      observaciones: '',
      periodoVigencia: '',
      optionSelected: null,
      optionsFases: [],
      newPlan: {},
      file: null
    };
  },
  created () {
    this.clean();
    this.$store
      .dispatch(types.ACTION_GET_FASES_INDICADORAUE, {})
      .then(response => {
        this.optionsFases = response.data.fases;
      });
  },
  watch: {
    value: {
      handler: function () {
        this.clean();
        this.valueLocal = this.value;
        this.$emit('input', this.valueLocal);
      },
      immediate: true
    }
  },
  methods: {
    cancel () {
      this.clean();
      this.$emit('input', false);
      this.$v.$reset();
    },
    clean () {
      this.nombre = '';
      this.observaciones = '';
      this.periodoVigencia = '';
      this.optionSelected = null;
      this.file = null;
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$error) {
        this.newPlan = {
          nombre: this.nombre,
          fase: this.optionSelected,
          periodoVigencia: this.periodoVigencia,
          observaciones: this.observaciones,
          planAdjuntoNombre: this.file ? this.file.name : '',
          filePlanAdjunto: this.file ? this.file : ''
        };
        this.$v.$reset();
        this.$emit('input', false);
        this.$eventHub.$emit('saveNewPlan', this.newPlan);
      }
    },
    isValidFrom () {
      return (this.nombre !== '' && this.nombre !== null) &&
      (this.periodoVigencia !== '' && this.periodoVigencia !== null) &&
      this.optionSelected !== null;
    },
    onRejected () {
      this.showError(`No es un fichero valido, debe ser .pdf y tamaño maximo 10MB`);
    }
  }
};
</script>

<style lang="scss" scoped>
.card-authorization {
  min-width: 700px;
  .header {
    padding-top: 18px;
    #title-card-authorization {
      font-family: DINPro;
      font-size: 24px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $azulcabecera;
    }
  }
  .container-actions {
    padding-top: 15px;
  }
  .container-auth {
    padding-top: 20px;
    padding-bottom: 25px;
    .title-option {
      font-family: DINPro;
      font-size: 15px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #5c5c5c;
      padding-bottom: 20px;
    }
  }
  &::v-deep {
    .q-field--standard .q-field__control:before {
      border-bottom-color: rgba(89, 89, 89, 0.5) !important;
    }
  }
}
.q-dialog__inner {
  div::v-deep {
    border-radius: 12px !important;
  }
  .fase {
    padding-right: 5px;
  }
  .periodo {
    padding-left: 5px;
  }
  .file {
    padding-right: 5px;
    padding-bottom: 20px;
  }
}
.q-card {
  padding-left: 40px;
  padding-right: 40px;
}
</style>
